import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, XCircle, Dumbbell, Moon } from "lucide-react";
import api from "../lib/api";
import { Loader, Pill } from "../components/common";

export default function Program() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/customer/assignments").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  if (!items) return <Loader />;

  const grouped = items.reduce((acc, a) => { (acc[a.scheduled_date] ||= []).push(a); return acc; }, {});
  const dates = Object.keys(grouped).sort();
  const today = new Date().toISOString().slice(0, 10);

  const statusIcon = (s) => s === "completed" ? <CheckCircle2 className="w-5 h-5 text-success" /> : s === "missed" ? <XCircle className="w-5 h-5 text-brand" /> : <Circle className="w-5 h-5 text-tertiary" />;

  return (
    <div className="p-5">
      <h1 className="font-heading text-4xl">My Program</h1>
      <p className="text-secondary text-sm mt-1">Your full training schedule.</p>
      <div className="mt-6 space-y-5">
        {dates.map((d) => (
          <div key={d}>
            <div className="flex items-center gap-2 mb-2">
              <span className={`label-xs ${d === today ? "text-brand" : ""}`}>{d === today ? "Today" : new Date(d + "T00:00:00").toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" })}</span>
              <div className="flex-1 h-px bg-border" />
            </div>
            {grouped[d].map((a) => (
              a.is_rest ? (
                <div key={a.id} data-testid={`program-item-${a.id}`} className="w-full card-surface rounded-xl p-4 flex items-center gap-3 mb-2 opacity-70">
                  <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center"><Moon className="w-5 h-5 text-tertiary" /></div>
                  <div className="flex-1">
                    <p className="font-semibold">Rest Day</p>
                    <p className="text-xs text-secondary">Recovery & recharge</p>
                  </div>
                </div>
              ) : (
                <button key={a.id} data-testid={`program-item-${a.id}`} onClick={() => navigate(`/app/workout/${a.id}`)}
                  className="w-full card-surface rounded-xl p-4 flex items-center gap-3 mb-2 hover:border-brand transition-all text-left">
                  <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center"><Dumbbell className="w-5 h-5 text-brand" /></div>
                  <div className="flex-1">
                    <p className="font-semibold">{a.workout_name}</p>
                    <p className="text-xs text-secondary">{a.exercises?.length} exercises · {a.duration_min} min</p>
                  </div>
                  {a.flagged && <Pill tone="warning">Pain</Pill>}
                  {statusIcon(a.status)}
                </button>
              )
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
